import {
  type TeamExternalIntegration,
  type ResponseBodyEvaluation,
  type PredicateType,
  type EndpointResponse
} from 'types/api/status-checks/status-check'
import { IntegrationType } from 'utils/team-external-integrations/team-external-integration-types'
import { ENDPOINT_URLS } from 'utils/third-party'

export const dataDogUS1FedStatusCheckIntegration: TeamExternalIntegration = {
  name: 'Datadog US1 FED',
  type: IntegrationType.DatadogUS1Fed,
  authUrl: `${ENDPOINT_URLS.datadog_us1_fed}v2/current_user/application_keys`,
  isPrivateNetworkIntegration: false,
  headers: [
    { key: 'DD-API-KEY', value: '', label: 'API Key' },
    {
      key: 'DD-APPLICATION-KEY',
      value: '',
      label: 'Application Key'
    }
  ],
  url: ENDPOINT_URLS.datadog_us1_fed,
  sortIndex: 0
}

export const datadogUS1FedMonitorRegex = new RegExp(
  '^https:\\/\\/(app|api).ddog-gov.com\\/(monitors|api/v1/monitor)\\/(.+\\d)'
)

export const datadogUS1FedResponseBodyEvaluationConfiguration: ResponseBodyEvaluation =
  {
    op: 'AND',
    predicates: [
      {
        jpQuery: '.overall_state',
        type: 'String' as PredicateType,
        comparator: 'EQU',
        rValue: 'OK'
      }
    ]
  }

export function getDatadogUS1FEDMonitorIdFromUrl(url: string): string {
  return datadogUS1FedMonitorRegex.exec(url)?.[3]
}

export function convertToDatadogUS1FedApiUrl(url: string): string {
  if (datadogUS1FedMonitorRegex.test(url)) {
    const isAPIUrl =
      datadogUS1FedMonitorRegex.exec(url)?.[2] === 'api/v1/monitor'
    const monitorId = getDatadogUS1FEDMonitorIdFromUrl(url)

    if (isAPIUrl) {
      return url
    }

    if (monitorId) {
      return `https://app.ddog-gov.com/api/v1/monitor/${monitorId}`
    }
  }

  return null
}

export function getDatadogUS1FedMonitorName(
  testEndpointResponse: EndpointResponse
): string {
  return JSON.parse(testEndpointResponse?.responseBody)?.name
}
